import { routerStore } from "csi/state/rootStore";
import Copy from "csi/table/Copy";
import NewSnapshotTemplateDialog from "csi/threeD/snapshotTemplates/dialogs/NewSnapshotTemplateDialog";
import SnapshotTemplateDialogStore from "csi/threeD/snapshotTemplates/dialogs/SnapshotTemplateDialogStore";
import { SnapshotTemplateId } from "csi/threeD/snapshotTemplates/snapshotUtils";
import xml from "csi/xml";
import declare from "dojo/_base/declare";

const CopySnapshotTemplate = declare(Copy, {
	
	/** Type of node to be created */
	nodeType: null, 
	
	/**
	 * @override
	 * Open React dialog
	 */

	preProcess(): void {
		const node = this.getNode();
		const {
			[xml.ATTR_TYPE]: type,
			$URL: url,
		  } = node;
		this.nodeType = type;

		const onSave = async (jsonResponse): Promise<void> => {
			this.processReact(jsonResponse);
		};

		const onCancel = (): void => {
			this.onCancelReactDialog();
		};

		const store = new SnapshotTemplateDialogStore(onCancel, onSave, this.m_writer, type as SnapshotTemplateId);

		this.useReactDialog(routerStore.openDialog(NewSnapshotTemplateDialog, {
			store,
			isCopyTemplate: true,
			selectedTemplate: url,
		}));
	},

	/**
	 * @override
	 * Return newly created Node
	 */
	getNewNodes() {
		return this.m_response.getNodesOfType(this.nodeType);
	},

});

export = CopySnapshotTemplate;